import React from 'react';

interface WarningAlertProps {
	message: string;
}

export const WarningAlert: React.FC<WarningAlertProps> = ({ message }) => {
	return (
		<div className="p-3 bg-red-50 border border-red-200 rounded">
			<div className="flex items-center">
				<svg className="w-5 h-5 text-red-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
					<path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
				</svg>
				<span className="text-red-700 font-medium text-sm">
					{message}
				</span>
			</div>
		</div>
	);
};

export default WarningAlert;
